module.exports = __webpack_public_path__ + "static/pic02-e665016bbb5564ed5b067ac57819d2dc.jpg";